const TextRightInActive = ({ quat }) => {
   return (
      <>
         <svg width="210" height="178" viewBox="0 0 210 178" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="177.216" x2="210" y2="177.216" stroke="url(#paint0_linear_66_552_rtin)" strokeWidth="1.56134" />
            <path d="M105.619 44.5038L187.034 91.5122L187.035 109.79L105.62 62.7813L105.619 44.5038Z" fill="#6E6E6E" />
            <path d="M24.2028 91.5105L105.618 44.502L105.617 62.7796L24.2018 109.788L24.2028 91.5105Z" fill="#5A5A5A" />
            <rect width="94.0117" height="94.0117" transform="matrix(0.866041 0.499972 -0.866041 0.499972 105.619 62.1265)" fill="#AAAAAA" />
            <path d="M24.2019 91.5051L105.617 138.514L105.618 156.138L24.2029 109.13L24.2019 91.5051Z" fill="url(#paint1_linear_66_552_rtin)" />
            <path d="M105.619 138.512L187.034 91.5035L187.033 109.128L105.618 156.137L105.619 138.512Z" fill="url(#paint2_linear_66_552_rtin)" />
            <rect x="0.866041" width="93.0117" height="93.0117" transform="matrix(0.866041 -0.499972 0.866041 0.499972 24.3179 91.9418)" fill="url(#paint3_linear_66_552_rtin)" stroke="url(#paint4_linear_66_552_rtin)" />
            <g opacity="0.6" filter="url(#filter0_f_66_552_rtin)">
               <ellipse cx="105.491" cy="91.3075" rx="37" ry="6" transform="rotate(-29.7431 105.491 91.3075)" fill="black" />
            </g>
            <text transform="matrix(0.86601 -0.500028 -3.18907e-05 1 56.2104 42.1583)" fill="white" xmlSpace="preserve" style={{ whiteSpace: "pre" }}  fontSize="58.5502" fontWeight="800" letterSpacing="0em">
               <tspan x="0" y="56.791">{quat}</tspan>
            </text>
            <defs>
               <filter id="filter0_f_66_552_rtin" x="59.2261" y="58.2214" width="92.5305" height="66.1721" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_66_552" />
               </filter>
               <linearGradient id="paint0_linear_66_552_rtin" x1="0" y1="178.497" x2="210" y2="178.497" gradientUnits="userSpaceOnUse">
                  <stop stopColor="white" stopOpacity="0.47" />
                  <stop offset="1" stopColor="#020202" />
               </linearGradient>
               <linearGradient id="paint1_linear_66_552_rtin" x1="64.9097" y1="115.009" x2="57.2779" y2="128.227" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#262626" />
                  <stop offset="1" stopColor="#383838" />
               </linearGradient>
               <linearGradient id="paint2_linear_66_552_rtin" x1="146.326" y1="115.008" x2="153.958" y2="128.225" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#262626" />
                  <stop offset="1" stopColor="#383838" />
               </linearGradient>
               <linearGradient id="paint3_linear_66_552_rtin" x1="47.0059" y1="0" x2="47.0059" y2="94.0117" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#262626" />
                  <stop offset="1" stopColor="#383838" />
               </linearGradient>
               <linearGradient id="paint4_linear_66_552_rtin" x1="58.6424" y1="-10.3787" x2="-28.8752" y2="58.2269" gradientUnits="userSpaceOnUse">
                  <stop offset="0.561269" stopColor="#282828" />
                  <stop offset="1" stopColor="white" />
               </linearGradient>
            </defs>
         </svg>
      </>
   )
}
export default TextRightInActive;